import * as React from 'react'

function QuestionIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.463 13.333a2.66 2.66 0 011.652-2.463 2.684 2.684 0 012.917.578 2.664 2.664 0 01.58 2.906A2.669 2.669 0 0116.139 16M16.14 18v-2"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.098 21.333V10.667c0-1.768.704-3.464 1.959-4.714A6.702 6.702 0 0110.787 4h10.704c1.775 0 3.476.702 4.73 1.953a6.655 6.655 0 011.96 4.714v10.666a6.655 6.655 0 01-1.96 4.714A6.702 6.702 0 0121.492 28H10.787a6.702 6.702 0 01-4.73-1.953 6.655 6.655 0 01-1.96-4.714z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.14 21.267a.067.067 0 00-.062.04.066.066 0 00.014.074.067.067 0 00.095-.095.067.067 0 00-.048-.02"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { QuestionIcon }
